import { c as _c } from "react/compiler-runtime";
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useTheme } from 'next-themes';
import { flushSync } from 'react-dom';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { THEMES } from '@/constants/themes';
export function ThemeSwitcher() {
  const $ = _c(16);
  const {
    setTheme
  } = useTheme();
  const t = useTranslations();
  let t0;
  if ($[0] !== setTheme) {
    t0 = function handleThemeChange(theme) {
      if (!("startViewTransition" in document) || globalThis.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setTheme(theme);
        return;
      }
      document.startViewTransition(() => {
        flushSync(() => {
          setTheme(theme);
        });
      });
    };
    $[0] = setTheme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleThemeChange = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("theme-toggle.toggle-theme");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SunIcon className="dark:hidden" />;
    t3 = <MoonIcon className="hidden dark:block" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1) {
    t4 = <DropdownMenuTrigger render={<Button variant="ghost" size="icon" aria-label={t1} data-testid="theme-toggle">{t2}{t3}</Button>} />;
    $[6] = t1;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleThemeChange || $[9] !== t) {
    t5 = THEMES.map(theme_0 => <DropdownMenuItem key={theme_0.value} onClick={() => {
      handleThemeChange(theme_0.value);
    }} data-testid={`theme-option-${theme_0.value}`}>{theme_0.icon}{t(theme_0.labelKey)}</DropdownMenuItem>);
    $[8] = handleThemeChange;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <DropdownMenuContent align="end" className="min-w-36">{t5}</DropdownMenuContent>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <DropdownMenu>{t4}{t6}</DropdownMenu>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}